/**
 * Filter all the errors that don't contain a fieldName
 *
 * @param {Array} errors
 *
 * @returns {Array}
 */
export default errors =>
  errors.filter(({ data = {} }) => !data || (!data.fieldName && !data.flightId))
